import { signOut } from 'aws-amplify/auth';
import { Hub, HubCapsule } from 'aws-amplify/utils';
import { UsersApi } from 'services/users/users.api';

import { ILoginType, LOGIN_TYPE, SOCIAL_PROVIDERS } from 'interfaces/auth';

import ToastService from './ToastService';

export function listenAuthorizationEvents(
  eventName: string,
  cb: (eventPayload: HubCapsule<string, any>) => void,
): void {
  Hub.listen('auth', ({ payload }: any) => {
    const { event, data } = payload;

    if (event === eventName) {
      cb(data);
    }
  });
}

export async function userLogOut(): Promise<void> {
  try {
    await UsersApi.logout();
    await signOut({ global: true });
  } catch (error) {
    if (error instanceof Error) {
      ToastService.showError(error.message);
    }

    if (process.env.NODE_ENV === 'development') {
      console.error('Detailed logout error:', error instanceof Error ? error.message : 'Unknown error');
    }
  }
}

export function getLoginType(username?: string): ILoginType | null {
  const prefixes = Object.values(SOCIAL_PROVIDERS);

  if (!username) {
    return null;
  }

  for (const prefix of prefixes) {
    if (username.startsWith(prefix)) {
      return prefix.toUpperCase() as ILoginType;
    }
  }

  return LOGIN_TYPE.GROWEXA;
}
